import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom'
import * as PAGES from 'constants/app-paths'
import CheckoutContext from 'contexts/CheckoutContext'
import useCheckoutContext from 'hooks/useCheckoutContext'
import CustomerPendingsContext from 'contexts/CustomerPendingsContext'
import useCustomerPendingsContext from 'hooks/useCustomerPendingsContext'

import { Header } from 'ui-components/Header'
import { TopMenu } from 'components/TopMenu'
import { BeforeUnload } from 'components/BeforeUnload'

import { Login } from 'views/Login'

// Dashboard
import { Dashboard } from 'views/Dashboard'

// Produtos
import { ProductsList } from 'views/Products/ProductsList'
import { ProductInfo } from 'views/Products/ProductInfo'
import { ManufacturersList } from 'views/Products/Manufacturers/ManufacturersList'
import { ProductCategoriesList } from 'views/Products/ProductCategories'
import { ProductGroupsList } from 'views/Products/ProductGroups'
import { ProductStockTracking } from 'views/Products/ProductStockTracking'
import { Prices } from 'views/Products/Prices'

// Clientes
import { CustomersList } from 'views/Customers/CustomersList'
import { CustomerInfo } from 'views/Customers/CustomerInfo'

// Configurações
import { SalesChannels } from 'views/Settings/SalesChannels'
import { PaymentMethodsList } from 'views/Settings/PaymentMethods/PaymentMethodsList'
import { PaymentMethodInfo } from 'views/Settings/PaymentMethods/PaymentMethodInfo'

// Relatórios
import { DailyReport } from 'views/Reports/DailyReport'
import { ReceiptsReport } from 'views/Reports/ReceiptsReport'
import { CustomerPurchasesPayments } from 'views/Analytics/Customers'

// Vendas
import { OrdersList } from 'views/Sales/Orders/OrdersList'
import { Order } from 'views/Sales/Orders/Order'

// Checkout
import { CustomerPendings } from 'views/Checkout/CustomerPendings'
import { Payment } from 'views/Checkout/Payment'
import { Confirmation } from 'views/Checkout/Confirmation'

// Pagamentos
import { Print as PrintPayment } from 'views/Payments/Print'

// Estoque
import { StockActivitiesList } from 'views/Stock/StockActivitiesList'

import PrivateRoute from './PrivateRoute'

export default function Routes() {
  const checkout = useCheckoutContext()
  const customerPendings = useCustomerPendingsContext()

  const renderHeader = () => (
    <Header>
      <TopMenu />
    </Header>
  )

  return (
    <Router>
      <Switch>
        <Route path={PAGES.LOGIN}>
          <Login />
        </Route>

        <PrivateRoute path={PAGES.PRODUCTS} exact>
          {renderHeader()}
          <ProductsList />
        </PrivateRoute>

        <PrivateRoute path={PAGES.PRODUCT_INFO} exact>
          {renderHeader()}
          <ProductInfo />
        </PrivateRoute>

        <PrivateRoute path={PAGES.PRODUCT_STOCK_TRACKING} exact>
          {renderHeader()}
          <ProductStockTracking />
        </PrivateRoute>

        <PrivateRoute path={PAGES.MANUFACTURERS} exact>
          {renderHeader()}
          <ManufacturersList />
        </PrivateRoute>

        <PrivateRoute path={PAGES.PRODUCT_CATEGORIES} exact>
          {renderHeader()}
          <ProductCategoriesList />
        </PrivateRoute>

        <PrivateRoute path={PAGES.PRODUCT_GROUPS} exact>
          {renderHeader()}
          <ProductGroupsList />
        </PrivateRoute>

        <PrivateRoute path={PAGES.PRODUCT_PRICES} exact>
          {renderHeader()}
          <Prices />
        </PrivateRoute>

        <PrivateRoute path={PAGES.CUSTOMERS} exact>
          {renderHeader()}
          <CustomersList />
        </PrivateRoute>

        <PrivateRoute path={PAGES.CUSTOMER_INFO} exact>
          {renderHeader()}
          <CustomerInfo />
        </PrivateRoute>

        <PrivateRoute path={PAGES.ORDERS} exact>
          {renderHeader()}
          <OrdersList />
        </PrivateRoute>

        <PrivateRoute path={PAGES.REPORT_DAILY} exact>
          {renderHeader()}
          <DailyReport />
        </PrivateRoute>

        <PrivateRoute path={PAGES.RECEIPT_REPORT} exact>
          {renderHeader()}
          <ReceiptsReport />
        </PrivateRoute>

        <PrivateRoute path={PAGES.ANALYTICS_CUSTOMERS} exact>
          {renderHeader()}
          <CustomerPurchasesPayments />
        </PrivateRoute>

        <PrivateRoute path={PAGES.SALES_CHANNELS} exact>
          {renderHeader()}
          <SalesChannels />
        </PrivateRoute>

        <PrivateRoute path={PAGES.PAYMENT_METHODS} exact>
          {renderHeader()}
          <PaymentMethodsList />
        </PrivateRoute>

        <PrivateRoute path={PAGES.PAYMENT_METHOD_INFO} exact>
          {renderHeader()}
          <PaymentMethodInfo />
        </PrivateRoute>

        <PrivateRoute path={PAGES.DASHBOARD} exact>
          {renderHeader()}
          <Dashboard />
        </PrivateRoute>

        <PrivateRoute path={PAGES.PAYMENT_PRINT} exact>
          <PrintPayment />
        </PrivateRoute>

        <PrivateRoute path={PAGES.STOCK_ACTIVITY} exact>
          {renderHeader()}
          <StockActivitiesList />
        </PrivateRoute>

        <CheckoutContext.Provider value={checkout}>
          <CustomerPendingsContext.Provider value={customerPendings}>
            <PrivateRoute path={PAGES.ORDER} exact>
              {renderHeader()}
              <Order />
            </PrivateRoute>

            <BeforeUnload>
              <PrivateRoute path={PAGES.CHECKOUT_CUSTOMER_PENDINGS} exact>
                {renderHeader()}
                <CustomerPendings />
              </PrivateRoute>

              <PrivateRoute path={PAGES.CHECKOUT_PAYMENT} exact>
                {renderHeader()}
                <Payment />
              </PrivateRoute>

              <PrivateRoute path={PAGES.CHECKOUT_CONFIRMATION} exact>
                {renderHeader()}
                <Confirmation />
              </PrivateRoute>
            </BeforeUnload>
          </CustomerPendingsContext.Provider>
        </CheckoutContext.Provider>
      </Switch>
    </Router>
  )
}
